export const getTrackingParametersNamespace = (namespace: string) => `${namespace}_tracking_parameters`;
